"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reduxPlugin_1 = require("./reduxPlugin");
exports.createReduxPlugin = reduxPlugin_1.createReduxPlugin;
var reducer_1 = require("./reducer");
exports.routerReducer = reducer_1.routerReducer;
var middleware_1 = require("./middleware");
exports.createRouterMiddleware = middleware_1.default;
var actions_1 = require("./actions");
exports.triggerTransition = actions_1.triggerTransition;
//# sourceMappingURL=index.js.map